export class TipoDocumento{
    public constructor(
        public id :String = "",
        public nombre :String = "",
        public descripcion :String = "",
        public usuario_id:String = null
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tipo-documento.ts